export default __webpack_public_path__ + "static/media/Insta.61fed726.svg";